import React from "react"
import ChooseRestaurant from "../../components/ChooseRestaurant/ChooseRestaurant"
import "./ChooseRestaurantPage.scss"

const ChooseRestaurantPage = (props) => (
  <div id="ChooseRestaurantPage">
    <section className="date-chat-window">
      <ChooseRestaurant {...props} />
    </section>
  </div>
)

export default ChooseRestaurantPage
